<template>
    <Button
        :loading="loading"
        :disabled="disabled"
        @click="emit('click')"
        class="p-button-outlined"
        v-tooltip.top="tooltip"
        :class="{ 'p-button-success': success, 'p-button-danger': error }"
    >
        <ProgressSpinner v-if="loading" style="width: 16px; height: 16px" />
        <span v-if="icon != '' && loading !== true" class="material-symbols-outlined select-none" style="font-size: 16px">{{ computedIcon }}</span>
        <span style="padding-left: 6px">{{ computedLabel }}</span>
    </Button>
</template>

<script setup>
import ProgressSpinner from 'primevue/progressspinner';
import { computed } from 'vue';

import { defineEmits, defineProps } from 'vue';

const computedIcon = computed(() => {
    if (props.success) {
        return 'check';
    }

    if (props.error) {
        return 'close';
    }

    return props.icon;
});

const computedLabel = computed(() => {
    if (props.loading) {
        return props.loadingLabel || props.label;
    }

    if (props.error) {
        return props.errorLabel || props.label;
    }

    if (props.success) {
        return props.successLabel || props.label;
    }

    return props.label;
});

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false,
    },
    tooltip: {
        type: String,
        default: '',
    },
    label: {
        type: String,
        default: 'Confirmar',
    },
    loadingLabel: {
        type: String,
    },
    errorLabel: {
        type: String,
    },
    successLabel: {
        type: String,
    },
    icon: {
        // https://fonts.google.com/icons
        type: String,
        default: 'check',
    },
    loading: {
        type: Boolean,
        default: false,
    },
    error: {
        type: Boolean,
        default: false,
    },
    success: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['click']);
</script>

<style lang="scss">
$cor-spinner-personalizada: #0772b3; // HACK! HACK! HACK! HACK!

@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: $cor-spinner-personalizada;
    }
    40% {
        stroke: $cor-spinner-personalizada;
    }
    66% {
        stroke: $cor-spinner-personalizada;
    }
    80%,
    90% {
        stroke: $cor-spinner-personalizada;
    }
}
</style>
